import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b13726a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"height":"100%"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"86px","width":"86px"} }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"86px","width":"86px"} }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"86px","width":"86px"} }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"86px","width":"86px"} }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"86px","width":"86px"} }, null, -1))
const _hoisted_7 = { style: {"position":"absolute","bottom":"64px","display":"flex","width":"100%","z-index":"3"} }
const _hoisted_8 = { class: "auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_close_button = _resolveComponent("close-button")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_check_in_skip = _resolveComponent("check-in-skip")!
  const _component_question_header = _resolveComponent("question-header")!
  const _component_question_row = _resolveComponent("question-row")!
  const _component_check_in_form_vue = _resolveComponent("check-in-form-vue")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_check_in_success = _resolveComponent("check-in-success")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createBlock(_component_ion_content, { fullscreen: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_close_button, { onClick: _ctx.closeMe }, null, 8, ["onClick"]),
      _createElementVNode("div", _hoisted_1, [
        _withDirectives(_createVNode(_component_swiper, {
          onActiveIndexChange: _ctx.moop,
          onSwiper: _ctx.onSwiper,
          style: {"height":"calc(100% - 96px)","max-height":"calc(100vh - 96px)","overflow-y":"scroll"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_swiper_slide, { class: "pa-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_grid, { class: "ion-text-center full-height flex" }, {
                  default: _withCtx(() => [
                    _createElementVNode("h5", null, _toDisplayString(_ctx.$t("check.slide1")), 1),
                    _createVNode(_component_ion_row, { class: "ion-justify-content-center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, {
                          color: "primary",
                          style: {"font-size":"128px","color":"blue"},
                          icon: _ctx.checkmarkCircle
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_row, { class: "ion-justify-content-center pa-4 mx-4" }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t("check.slide1Body")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_row, null, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_swiper_slide, {
              class: "pa-4 full-height flex ion-text-start",
              style: {"justify-content":"flex-start"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_check_in_skip, {
                  body: _ctx.$t('check.slideBio'),
                  title: "BIO",
                  color: "#99ca3c"
                }, null, 8, ["body"])
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bioQuestions, (b, index) => {
              return (_openBlock(), _createBlock(_component_swiper_slide, {
                class: "pa-4 full-height flex ion-text-start",
                style: {"justify-content":"center"},
                key: b.body
              }, {
                default: _withCtx(() => [
                  (_ctx.init)
                    ? (_openBlock(), _createBlock(_component_ion_grid, {
                        key: 0,
                        class: "ion-text-center full-height flex"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_question_header, {
                            title: "BIO",
                            question: index + 1,
                            progress: _ctx.bioPercent,
                            color: "#99ca3c"
                          }, null, 8, ["question", "progress"]),
                          _createVNode(_component_question_row, {
                            question: b.body,
                            color: "success",
                            value: _ctx.localCheckInForm.responses[index],
                            onInput: 
                ($event) => {
                  _ctx.localCheckInForm.responses[index] = {
                    category: b.category.name,
                    questionId: b.id,
                    response: $event,
                    topic: b.topic ? b.topic.name : '',
                  };
                  _ctx.delayedNextSlide();
                }
              
                          }, null, 8, ["question", "value", "onInput"]),
                          _createVNode(_component_ion_row, null, {
                            default: _withCtx(() => [
                              _hoisted_3
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024))
            }), 128)),
            _createVNode(_component_swiper_slide, {
              class: "pa-4 full-height flex ion-text-start",
              style: {"justify-content":"flex-start"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_check_in_skip, {
                  body: _ctx.$t('check.slidePsycho'),
                  title: "PSYCH",
                  color: "#58c4eb"
                }, null, 8, ["body"])
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.psychQuestions, (b, index) => {
              return (_openBlock(), _createBlock(_component_swiper_slide, {
                class: "pa-4 full-height flex ion-text-start",
                style: {"justify-content":"center"},
                key: b.body
              }, {
                default: _withCtx(() => [
                  (_ctx.init)
                    ? (_openBlock(), _createBlock(_component_ion_grid, {
                        key: 0,
                        class: "ion-text-center full-height flex"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_question_header, {
                            title: "PSYCH",
                            question: index + 1,
                            progress: _ctx.localCheckInForm.skipPsych ? 0 : _ctx.psychPercent,
                            color: "#58c4eb"
                          }, null, 8, ["question", "progress"]),
                          _createVNode(_component_question_row, {
                            question: b.body,
                            color: "primary",
                            disabled: _ctx.localCheckInForm.skipPsych,
                            value: _ctx.localCheckInForm.responses[4 + index],
                            onInput: 
                ($event) => {
                  _ctx.localCheckInForm.responses[4 + index] = {
                    category: b.category.name,
                    questionId: b.id,
                    response: $event,
                    topic: b.topic ? b.topic.name : '',
                  };
                  _ctx.delayedNextSlide();
                }
              
                          }, null, 8, ["question", "disabled", "value", "onInput"]),
                          _createVNode(_component_ion_row, null, {
                            default: _withCtx(() => [
                              _hoisted_4
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024))
            }), 128)),
            _createVNode(_component_swiper_slide, {
              class: "pa-4 full-height flex ion-text-start",
              style: {"justify-content":"flex-start"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_check_in_skip, {
                  body: _ctx.$t('check.slideSocial'),
                  title: "SOCIAL",
                  color: "#f47b4b"
                }, null, 8, ["body"])
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.socialQuestions, (b, index) => {
              return (_openBlock(), _createBlock(_component_swiper_slide, {
                class: "pa-4 full-height flex ion-text-start",
                style: {"justify-content":"center"},
                key: b.body
              }, {
                default: _withCtx(() => [
                  (_ctx.init)
                    ? (_openBlock(), _createBlock(_component_ion_grid, {
                        key: 0,
                        class: "ion-text-center full-height flex"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_question_header, {
                            title: "SOCIAL",
                            question: index + 1,
                            progress: _ctx.localCheckInForm.skipSocial ? 0 : _ctx.socialPercent,
                            color: "#f47b4b"
                          }, null, 8, ["question", "progress"]),
                          _createVNode(_component_question_row, {
                            question: b.body,
                            color: "tertiary",
                            disabled: _ctx.localCheckInForm.disableSocial,
                            value: _ctx.localCheckInForm.responses[8 + index],
                            onInput: 
                ($event) => {
                  _ctx.localCheckInForm.responses[8 + index] = {
                    category: b.category.name,
                    questionId: b.id,
                    response: $event,
                    topic: b.topic ? b.topic.name : '',
                  };
                  _ctx.delayedNextSlide();
                }
              
                          }, null, 8, ["question", "disabled", "value", "onInput"]),
                          _createVNode(_component_ion_row, null, {
                            default: _withCtx(() => [
                              _hoisted_5
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024))
            }), 128)),
            _createVNode(_component_swiper_slide, {
              class: "pa-4 full-height flex ion-text-start",
              style: {"justify-content":"flex-start"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_check_in_skip, {
                  body: _ctx.$t('check.slideSpiritual'),
                  title: "SPIRIT",
                  color: "#9a57a3"
                }, null, 8, ["body"])
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.spiritQuestions, (b, index) => {
              return (_openBlock(), _createBlock(_component_swiper_slide, {
                class: "pa-4 full-height flex ion-text-start",
                style: {"justify-content":"center"},
                key: b.body
              }, {
                default: _withCtx(() => [
                  (_ctx.init)
                    ? (_openBlock(), _createBlock(_component_ion_grid, {
                        key: 0,
                        class: "ion-text-center full-height flex"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_question_header, {
                            title: "SPIRIT",
                            question: index + 1,
                            progress: _ctx.spiritPercent,
                            color: "#9a57a3"
                          }, null, 8, ["question", "progress"]),
                          _createVNode(_component_question_row, {
                            question: b.body,
                            color: "secondary",
                            value: _ctx.localCheckInForm.responses[12 + index],
                            onInput: 
                ($event) => {
                  _ctx.localCheckInForm.responses[12 + index] = {
                    category: b.category.name,
                    questionId: b.id,
                    response: $event,
                    topic: b.topic ? b.topic.name : '',
                  };
                  _ctx.delayedNextSlide();
                }
              
                          }, null, 8, ["question", "value", "onInput"]),
                          _createVNode(_component_ion_row, null, {
                            default: _withCtx(() => [
                              _hoisted_6
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024))
            }), 128)),
            _createVNode(_component_swiper_slide, { class: "pa-4" }, {
              default: _withCtx(() => [
                (_ctx.init)
                  ? (_openBlock(), _createBlock(_component_check_in_form_vue, {
                      key: 0,
                      style: {"height":"100%"},
                      loading: _ctx.loading
                    }, null, 8, ["loading"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["onActiveIndexChange", "onSwiper"]), [
          [_vShow, !_ctx.complete]
        ]),
        (_ctx.complete)
          ? (_openBlock(), _createBlock(_component_check_in_success, {
              key: 0,
              onClose: _ctx.closeWithData,
              class: "px-4 full-height flex"
            }, null, 8, ["onClose"]))
          : _createCommentVNode("", true)
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          (_ctx.activeSlide != 0 && _ctx.activeSlide != 1)
            ? (_openBlock(), _createBlock(_component_ion_button, {
                key: 0,
                fill: "empty",
                disabled: _ctx.loading || _ctx.activeSlide == 0 || _ctx.activeSlide == 1,
                onClick: _ctx.lastSlide,
                icon: "",
                class: "my-pointer mr-2 button-liner",
                style: _normalizeStyle({ opacity: _ctx.activeSlide != 0 ? '1' : '0' })
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_icon, {
                    color: "primary",
                    icon: _ctx.chevronBack
                  }, null, 8, ["icon"])
                ]),
                _: 1
              }, 8, ["disabled", "onClick", "style"]))
            : _createCommentVNode("", true),
          _createVNode(_component_ion_button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activeSlide == 21 ? _ctx.onSubmit() : _ctx.nextSlide())),
            disabled: _ctx.loading || !_ctx.canHitNext,
            color: "primary",
            mode: "md",
            class: "my-pointer mr-2 no-corners",
            style: {
            'max-width': '78vw'
          }
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                style: _normalizeStyle({width: _ctx.activeSlide != 0 && _ctx.activeSlide != 1 ? '348px' : '400px'})
              }, _toDisplayString(_ctx.activeSlide == 21 ?  'SUBMIT' : 'NEXT'), 5)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ], 512), [
        [_vShow, !_ctx.complete]
      ]),
      (
        _ctx.activeSlide == 1 ||
        _ctx.activeSlide == 6 ||
        _ctx.activeSlide == 11 ||
        _ctx.activeSlide == 16
      )
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.skipSection && _ctx.skipSection(...args))),
            class: "body-2 ion-text-center mt-2 w100 my-pointer my-underline",
            style: {"position":"absolute","bottom":"32px","left":"0px","z-index":"3"}
          }, " skip this section "))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}